import * as React from "react";
import MediaQuery from "react-responsive";
import YouTube from "react-youtube";

function YT(props: YouTubeProps): JSX.Element {
    return (
        <div>
            <MediaQuery minDeviceWidth={1280}>
                <YouTube videoId={props.videoId} opts={{
                    height: "720px",
                    playerVars: {
                        playlist: props.playlist
                    },
                    width: "1280px"
                }} />
            </MediaQuery>
            <MediaQuery minDeviceWidth={640} maxDeviceWidth={1279}>
                <YouTube videoId={props.videoId} opts={{
                    playerVars: {
                        playlist: props.playlist
                    }
                }} />
            </MediaQuery>
            <MediaQuery maxDeviceWidth={639}>
                <YouTube videoId={props.videoId} opts={{
                    height: "240px",
                    playerVars: {
                        playlist: props.playlist
                    },
                    width: "426px"
                }} />
            </MediaQuery>
        </div>
    );
}

interface YouTubeProps {
    playlist: string;
    videoId: string;
}

export { YT as YouTube };